import { useState } from "react";

import {
  Grid,
  InputAdornment,
  CircularProgress,
  IconButton,
  Typography
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import {
  TextField,
  LoadingButton,
  MatchingCompanyChips
} from "@aclymatepackages/atoms";
import { fetchOurApi } from "../../helpers/utils/apiCalls";

const DbCompanySelectModule = ({
  onCompanyNotFound,
  onCompanySelected,
  onSelectClick = () => {},
  label = "Enter your company's name",
  actionLabel = "Please select your company from these options",
  helperText
}) => {
  const [inputValue, setInputValue] = useState("");
  const [matchingCompanies, setMatchingCompanies] = useState([]);
  const [inputComplete, setInputComplete] = useState(false);
  const [companyFetchLoading, setCompanyFetchLoading] = useState(false);
  const [nextStepLoading, setNextStepLoading] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const fetchMatchingCompanies = async () => {
    setCompanyFetchLoading(true);

    const matchingCompanies = await fetchOurApi({
      path: `/companies/query-matching-companies`,
      method: "POST",
      data: { name: inputValue },
      callback: ({ matchingCompanies }) => matchingCompanies
    });

    setCompanyFetchLoading(false);
    setMatchingCompanies(matchingCompanies);
    return setInputComplete(true);
  };

  const onSelectCompany = async (companyId, name) => {
    setNextStepLoading(true);
    if (!companyId || companyId === "none") {
      await onCompanyNotFound(name);
      return onSelectClick();
    }

    await onCompanySelected(companyId, name);
    return onSelectClick();
  };

  return (
    <Grid container spacing={2} direction="column">
      <Grid item>
        <TextField
          disabled={companyFetchLoading}
          label={label}
          value={inputValue}
          setValue={setInputValue}
          onKeyPress={({ key }) => {
            if (key === "Enter") {
              return fetchMatchingCompanies();
            }
          }}
          helperText={
            helperText ||
            "Press enter or click the search icon to search for matching companies"
          }
          InputProps={{
            endAdornment: (
              <InputAdornment>
                <IconButton
                  disabled={companyFetchLoading}
                  onClick={fetchMatchingCompanies}
                >
                  {companyFetchLoading ? (
                    <CircularProgress size={20} />
                  ) : (
                    <SearchIcon />
                  )}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      </Grid>
      <Grid item container justifyContent="center"></Grid>
      {inputComplete && (
        <>
          <Grid item>
            <Typography variant="h6" align="center">
              {actionLabel}
            </Typography>
          </Grid>
          <Grid item>
            <MatchingCompanyChips
              matchingCompanies={matchingCompanies}
              selectedCompany={selectedCompany}
              setSelectedCompany={setSelectedCompany}
            />
          </Grid>
          <Grid item container spacing={2} justifyContent="center">
            <Grid item>
              {selectedCompany ? (
                <LoadingButton
                  isLoading={nextStepLoading}
                  label="Choose This Company"
                  variant="contained"
                  color="secondary"
                  onClick={() => onSelectCompany(selectedCompany)}
                />
              ) : (
                <LoadingButton
                  isLoading={nextStepLoading}
                  color="primary"
                  onClick={() => onSelectCompany("none", inputValue)}
                  label="I don't see my company"
                  variant="text"
                />
              )}
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};

const DbCompanySelect = (props) => {
  return <DbCompanySelectModule {...props} />;
};
export default DbCompanySelect;
